<template lang="pug">
v-container(fluid px-0 fill-height class=" tw-items-start tw-content-start tw-overflow-x-hidden tw-bg-gray-lighten-5")
  kubiqa-website-themes-theme-d-components-shared-top-navigation
  v-row(justify="center" class="  ")
    kubiqa-website-themes-theme-d-components-shared-gallery(:photos="photos")
  v-row(no-gutters justify="center" class=" d-flex tw-relative tw-z-10 tw-pt-4")
    v-col(cols="10" class="")
      v-container(class="tw-px-8 tw-bg-white tw-rounded-md info-container")
        v-row
          v-col(cols="auto")
            div(class="tw-bg-green-lighten-5 tw-rounded-full tw-px-3  tw-py-1")
              span(class="tw-text-green-darken-2 tw-text-sm") For {{ this.$faker().random.arrayElement(['Rent', 'Sale']) }}
        v-row
          v-col(cols="stretch")
            span(class="tw-text-xl tw-font-bold") {{ this.$faker().lorem.sentence(6) }}
          v-col(cols="auto")
            span(class=" font-weight-bold  tw-text-4xl tw-text-orange-darken-4") ${{ this.$faker().finance.amount(10000, 100000, 0) }}
        v-row(no-gutters align="center" justify="start" class="tw-pt-2 tw--ml-1")
          v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
            div(class="tw-w-6 tw-h-6 tw-flex ")
              v-icon(color=" blue-grey lighten-2" class="tw-mx-auto") mdi-map-marker-outline
          v-col(cols="auto" class=" tw-text-center")
            span(class="tw-ml-1 text-secondary") {{ this.$faker().address.county() }}, {{ this.$faker().address.stateAbbr() }}

        v-row(dense justify="start" class="tw-py-2 tw-pt-3")
          v-col(cols="auto" class="tw-mr-2")
            v-row(no-gutters align="center" justify="center")
              v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                div(class="tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-flex ")
                  v-icon(small color=" blue-grey lighten-2" class="tw-mx-auto") mdi-bed-king
              v-col(cols="auto" class=" tw-text-center")
                span(class="tw-ml-1 text-secondary tw-text-sm") {{ this.$faker().datatype.number({ min: 1, max: 4 }) }} Beds

          v-col(cols="auto" class="tw-mr-2")
            v-row(no-gutters align="center" justify="center")
              v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                div(class="tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-flex ")
                  v-icon(small color=" blue-grey lighten-2" class="tw-mx-auto") mdi-shower
              v-col(cols="auto" class=" tw-text-center")
                span(class="tw-ml-1 text-secondary tw-text-sm") {{ this.$faker().datatype.number({ min: 1, max: 4 }) }} Bath

          v-col(cols="auto" class="tw-mr-2")
            v-row(no-gutters align="center" justify="center")
              v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                div(class="tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-flex ")
                  v-icon(small color=" blue-grey lighten-2" class="tw-mx-auto") mdi-arrow-all
              v-col(cols="auto" class=" tw-text-center")
                span(class="tw-ml-1 text-secondary tw-text-sm") {{ this.$faker().datatype.number({ min: 200, max: 800 }) }} m <sup>2</sup>

  v-row(justify="space-around" class="tw-pt-2 ")
    v-col(cols="10")
      v-row
        v-col(cols="" class="")
          v-container(fluid p-0 class=" tw-bg-white tw-rounded-md info-container")
            v-row
              v-col(class="")
                span(class="tw-text-xl tw-font-bold") Description
            v-row
              v-col
                p
                  span {{ this.$faker().lorem.paragraphs(2) }}
                p
                  span {{ this.$faker().lorem.paragraphs(3) }}
          div(class="tw-py-4") 
          v-container(fluid p-0 class=" tw-bg-white tw-rounded-md info-container")
            v-row
              v-col(class="")
                span(class="tw-text-xl tw-font-bold") Detail
            v-row
              v-col
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds

              v-col
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
              v-col
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
          div(class="tw-py-4")
          v-container(fluid p-0 class=" tw-bg-white tw-rounded-md info-container")
            v-row
              v-col(class="")
                span(class="tw-text-xl tw-font-bold") Amenities
            v-row
              v-col
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
              v-col
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
              v-col
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class=" tw-rounded-full tw-bg-blueGray-lighten-5 tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(small color=" blue-grey lighten-3" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 ") {{ this.$faker().commerce.productName() }}
          div(class="tw-py-4")
          v-container(fluid p-0 class=" tw-bg-white tw-rounded-md info-container")
            v-row
              v-col(class="")
                span(class="tw-text-xl tw-font-bold") Location
            v-row
              v-col
                kubiqa-misc-map

        v-col(cols="4")
          v-container(class="tw-bg-white tw-rounded-md info-container tw-overflow-hidden")
            v-row(align="center" class="tw-bg-deepOrange-darken-3  tw-h-16")
              v-col(class=" ")
                span(class="tw-text-white tw-font-bold tw-text-xl") Contact
            v-row
              v-col(class="tw-bg-white")
                v-row
                  v-col
                    v-text-field(label="Your name" outlined color="#e2e2e2" hide-details class="py-2 theme-d-inputs")
                    v-text-field(label="Your phone" outlined color="#e2e2e2" hide-details class="py-2 theme-d-inputs")
                    v-text-field(label="Your email" outlined color="#e2e2e2" hide-details class="py-2 theme-d-inputs")
                    v-textarea(
                      height="220"
                      outlined
                      color="#e2e2e2"
                      class="theme-d-inputs"
                      hide-details
                      no-resize
                      placeholder="I'm interested in this property. Please send me additional information."
                    )
                    v-btn(
                      x-large
                      @click=""
                      block
                      color="deep-orange darken-3"
                      elevation="0"
                      class="tw-mt-6"
                    )
                      span(class="tw-font-bold") Send
  v-row(class="tw-pt-24")
    v-col

  kubiqa-website-themes-theme-d-components-shared-footer
</template>

<script>
export default {
  data() {
    return {
      photos: [],
    };
  },
  // updated() {
  //   this.fakePhotos();
  // },
  // created() {
  //   this.fakePhotos();
  // },
  mounted() {
    this.fakePhotos();
  },
  methods: {
    fakePhotos() {
      this.$store.dispatch('properties/getPexelGallery').then((response) => {
        this.photos = response;
      });
    },
  },
};
</script>

<style scoped>
.v-carousel >>> .v-btn {
  margin: 0px;
}

.theme-d-inputs >>> fieldset {
  border-color: #e2e2e2 !important;
}

.info-container {
  box-shadow: 0 1px 4px 0 rgba(24, 26, 32, 0.07);
}
</style>
